import styled from '@emotion/styled';
import { Container } from '@mui/material';

export const StyledContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(12.6, 0),
}));
